import * as React from "react";
import { Base } from "../../../../framework/base";
import { Dropdown } from "../Dropdown";
import { IInputButtonGroupButton, InputButtonGroup } from "../../Button/InputButtonGroup";
import { Box, Divider, MenuItem, SxProps, TextField, Theme, Typography } from "@mui/material";
import { useRef } from "react";

export interface IIdTitleDropdownItem {
    id: string;
    title: string;
    subTitle?: string;
    divider?: boolean;
    unselectable?: boolean;
}

export interface IIdTitleDropdownProp {
    index?: number;
    autoFocus?: boolean;
    menuRight?: boolean;
    disabled?: boolean;
    selectMode?: boolean;
    selectedId: string;
    startIcon?: React.ReactNode;
    tooltip?: string;
    items: IIdTitleDropdownItem[];
    buttons?: IInputButtonGroupButton[];
    sx?: SxProps<Theme>;
    onChange: (id: string) => void;
}

export const IdTitleDropdown = (props: IIdTitleDropdownProp) => {
    const itemsToActions = () => {
        return props.items.map(item => {
            return {
                title: item.title,
                divider: item.divider,
                selected: props.selectedId === item.id,
                onClick: item.unselectable
                    ? () => {}
                    : () => props.onChange(item.id)
            };
        });
    };
    
    const handleChange = (event) => {
        if (!props.onChange) return;
        props.onChange(event.target.value as string);
    };

    const selectRef = useRef();
    const buttonsRef = useRef<HTMLDivElement>(null);

    const getMenuProps = (ref) => {
        return {
            PaperProps: {
                style: {
                    width: ref.current?.offsetWidth,
                    maxHeight: "374px"
                }
            }
        };
    };
        
    if (props.buttons?.length > 0) {
        return (
            <TextField
                sx={props.sx}
                select
                SelectProps={{
                    ref: selectRef,
                    MenuProps: getMenuProps(selectRef),
                    sx: {
                        ".MuiSelect-icon": {
                            right: buttonsRef.current ? `${buttonsRef.current.offsetWidth + 18}px` : "0px",
                        }
                    }
                }}
                fullWidth
                value={props.selectedId}
                disabled={props.disabled}
                autoFocus={props.autoFocus}
                //required={props.required}
                size="small"
                InputProps={{
                    endAdornment: <Box ref={buttonsRef}><InputButtonGroup sx={{ marginLeft: "-4px" }} buttons={props.buttons} showButtons={true} /></Box>
                }}
                onChange={handleChange}
            >
                {props.items.map(item => {
                    if (item.divider) {
                        return <Divider key={item.id}>{item.title}</Divider>;
                    }
                    if (item.subTitle) {
                        return <MenuItem key={item.id} value={item.id} disabled={item.unselectable} title={`${item.title} ${item.subTitle}`} >
                            <Box display="flex" alignItems="center">
                                <Typography>{item.title}</Typography>
                                <Typography sx={{ marginLeft: "5px" }} variant="caption" color="text.secondary">{item.subTitle}</Typography>
                            </Box>
                        </MenuItem>;
                    }
                    return <MenuItem key={item.id} value={item.id} disabled={item.unselectable} title={item.title}>{item.title}</MenuItem>;
                })}
            </TextField>
        );
    }

    return (
        <Dropdown
            sx={props.sx}
            autoFocus={props.autoFocus}
            menuRight={props.menuRight}
            disabled={props.disabled}
            selectMode={!Base.isNullOrUndefined(props.selectMode) ? props.selectMode : true}
            selectedTitle={props.items.find(i => i.id === props.selectedId)?.title}
            startIcon={props.startIcon}
            tooltip={props.tooltip}
            actions={itemsToActions()}
        />
    );
};